document.addEventListener("DOMContentLoaded", function () {
  class BlockCollapsible extends HTMLDetailsElement {
    #animation = null;
    #boundHandleToggle;
    constructor() {
      super();
      this.summary = this.querySelector("summary");
      this.content = this.querySelector("summary ~ *");
      if (this.summary === null || this.content === null) return;
      this.#boundHandleToggle = this.#handleToggle.bind(this);
      this.summary.addEventListener("click", this.#boundHandleToggle);
      this.#checkInitialState();
    }
    #checkInitialState() {
      const inputs = [...this.querySelectorAll("input[type=checkbox]")];
      this.open = inputs.some(input => input.checked);
    }
    #handleToggle(event) {
      event.preventDefault();
      this.#animation?.cancel();
      if (!this.open) {
        this.#open();
      } else {
        this.#close();
      }
    }
    #open() {
      this.open = true;
      this.#animation = this.content.animate({
        height: ["0px", `${this.content.scrollHeight}px`]
      }, {
        duration: 250,
        easing: "cubic-bezier(0.4, 0, 0.2, 1)"
      });
    }
    #close() {
      this.#animation = this.content.animate({
        height: [`${this.content.scrollHeight}px`, "0px"]
      }, {
        duration: 200,
        easing: "cubic-bezier(0.4, 0, 0.2, 1)"
      });
      this.#animation.onfinish = () => {
        this.open = false;
      };
    }
  }
  customElements.define("block-collapsible", BlockCollapsible, {
    extends: "details"
  });
});